import { type RouteObject } from 'react-router';

export const routes: RouteObject[] = [
    {
        index: true,
        lazy: async () => {
            const { Home } = await import('@@routes/home/Home');

            return { Component: Home };
        },
    },
];
